import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import {
  PatientPlanService,
  PatientPlanDto,
} from "src/swagger/api.client.generated";
import { PatientPlans, CalendarPlanList } from "./home.model";
import * as m from "moment";

@Injectable({
  providedIn: "root",
})
export class HomeService {
  private currentPlanSource = new Subject();
  private loadPlansSource = new Subject<void>();
  private loadCalendarPlanListSource = new Subject<CalendarPlanList>();

  onCurrentplanChanged = this.currentPlanSource.asObservable();

  onPlansLoaded = this.loadPlansSource.asObservable();

  onCalendarPlanListLoaded = this.loadCalendarPlanListSource.asObservable();

  private hasCurrentPlanNow: boolean = false;
  private currentPlanId: number = 0;
  private Plans: PatientPlans = new PatientPlans();
  private CalendarPlans: CalendarPlanList = new CalendarPlanList();
  private isServiceLoaded: boolean = false;

  private patientPlans: PatientPlanDto[] = [];
  private favouritePlans: PatientPlanDto[] = [];

  constructor(private patientPlanService: PatientPlanService) {}

  updateCurrentPlan(value: number) {
    this.currentPlanId = value;
    this.hasCurrentPlanNow = value !== 0;
  }

  get getAllPatientPlans() {
    return this.patientPlans;
  }

  get getAllFavouritePlans() {
    return this.favouritePlans;
  }

  get getAllPlans() {
    return this.Plans;
  }

  get getAllCalendarPlans() {
    return this.CalendarPlans;
  }

  get serviceLoaded() {
    return this.isServiceLoaded;
  }

  get hasCurrentPlan(): boolean {
    return this.hasCurrentPlanNow;
  }

  get hasCurrentPlanId(): number {
    return this.currentPlanId;
  }

  get getPreviousPlans() {
    return this.Plans.parentPlans;
  }
  get getFavouritePlans() {
    return this.Plans.favParentPlans;
  }

  // Computed fresh on every access (rather than cached from the last fetch) so that a plan
  // fetched before midnight correctly stops being "today's plan" once the day rolls over,
  // even if the app session stays open with no refetch in between.
  get getCurrentPlan(): PatientPlanDto | null {
    const today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);

    return (
      this.patientPlans.find((d) => {
        const planDate = new Date(d.startDate);
        return planDate >= startOfDay && planDate <= endOfDay;
      }) ?? null
    );
  }

  init() {
    this.isServiceLoaded = false;
    this.getPlansFromDb();
  }

  /**
   * Get the plans from the database
   * @returns void
   */
  private getPlansFromDb() {
    const self = this;
    const cd = m().format("YYYY-MM-DD HH:mm:ss");
    const pp = new PatientPlans();

    this.patientPlanService
      .getPatientPlans(cd)
      .subscribe((a: PatientPlanDto[]) => {
        this.patientPlans = a;
        self.loadPlansSource.next();
      });
  }
}
